// JsFromRoutes CacheKey 57d571d66739c294a69b5be17907f6cb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/god-mode/ai-costs'),
}
